import { z } from 'zod';

export const ContactDataSchema = z
  .object({
    firstName: z.string().describe('The contact’s first name, if available.'),
    lastName: z.string().describe('The contact’s last name, if available.'),
    phoneNumber: z
      .string()
      .describe(
        'The contact’s phone number, if provided. The value of the number should be in the format: +12345678901.',
      ),
    email: z.string().describe('The contact’s email address, if available.'),
  })
  .describe(
    'Basic contact data such as name, phone number, and email address. If certain information is not available, leave it empty.',
  );

export const ContactDataSchemaWithConstrains = z.object({
  firstName: z.string().min(1, 'first name cannot be empty'),
  lastName: z.string().min(1, 'last name cannot be empty'),
  phoneNumber: z
    .string()
    .regex(/^\+\d+$/, 'must start with + followed by numbers only'),
  email: z.union([z.string().email(), z.literal('')]),
});

export type ContactData = z.infer<typeof ContactDataSchema>;
